export const NO_FILTER = 'no_filter';
export const PHONE_FILTER = 'phone_filter';
export const OPERATOR_FILTER = 'operator_filer';
export const REFERENCER_FILTER = 'reference_filter';
export const DATE_FILTER = 'date_filer';
